import styled from 'styled-components';
import { Typography } from '~/ui/components';
import { themeToggleColor } from '~/common/utils/theme';

export const TemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const TemplateName = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  weight: 600,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))`
  margin: 0;
`;

export const TemplateParam = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  weight: 400,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))`
  margin: 0;
`;
